export default function truncate(value: string, length = 35) {
  return value.length <= length ? value : value.substring(0, length) + "...";
}
